/**
 * Module sample.
 * @param msg
 */
export function consoleLog(msg: string) {
  console.log(msg);
}
